// import React, { useEffect, useState } from "react";
// import axiosClient from "../global/Globalapi";
// import { OrderStatus } from "./OrderFunction";
// import axios from "axios";
// import { showAlert } from "../Components/DynamicComp/Alert";

// const OrderCard = ({ orderId, items, handleRefetch }) => {
//   const baseURL = axiosClient?.defaults?.baseURL || "";

//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [modalStatus, setModalStatus] = useState("");
//   const [packagedQty, setPackagedQty] = useState({});
//   const [barcodeInput, setBarcodeInput] = useState("");

//   useEffect(() => {
//     if (selectedProduct) setModalStatus(selectedProduct.status || "");
//   }, [selectedProduct]);

//   const orderDetails = items[0] || {};
//   if (!orderDetails) return null;

//   const formatDate = (dateString) => {
//     if (!dateString) return "-";
//     return new Date(dateString).toLocaleString();
//   };

//   const formatCurrency = (amount) =>
//     new Intl.NumberFormat("en-IN", {
//       style: "currency",
//       currency: "INR",
//     }).format(Number(amount || 0));

//   const calculateTotalAmount = () =>
//     items.reduce((total, item) => total + Number(item.amount), 0);

//   const getStatusBadgeClasses = (status) => {
//     switch ((status || "").toLowerCase()) {
//       case "success":
//         return "bg-green-100 text-green-800 border-green-200";
//       case "pending":
//         return "bg-yellow-100 text-yellow-800 border-yellow-200";
//       case "failed":
//         return "bg-red-100 text-red-800 border-red-200";
//       case "shipped":
//         return "bg-blue-100 text-blue-800 border-blue-200";
//       case "delivered":
//         return "bg-emerald-100 text-emerald-800 border-emerald-200";
//       case "cancelled":
//         return "bg-gray-200 text-gray-800 border-gray-300";
//       default:
//         return "bg-gray-100 text-gray-800 border-gray-200";
//     }
//   };

//   const handleProductClick = (item) => setSelectedProduct(item);
//   const closeModal = () => {
//     setBarcodeInput("");
//     setSelectedProduct(null);
//   };

//   // ⭐ FINAL BARCODE HANDLER (FULLY CORRECT)
//   const handleBarcodeCheck = async () => {
//     if (!barcodeInput.trim()) {
      
//       showAlert({
//         type: "Failed",
//         title: "Enter Barcode ",
//         duration: 2500,
//       });
//       return;
//     }

//     if (!selectedProduct) {
//       showAlert({
//         type: "Failed",
//         title: "Select a product first",
//         duration: 2500,
//       });
//       return;
//     }

//     try {
//       const res = await axios.get(
//         `http://localhost:5000/api/batch/code/${barcodeInput}`
//       );

//       if (!res.data.success) {
//         showAlert({
//         type: "Failed",
//         title: "Invalid Barcode ",
//         duration: 2500,
//       });
//         return;
//       }

//       const batch = res.data;

//       // 1️⃣ Product mismatch
//       if (batch.product_id !== selectedProduct.product_id) {
//          showAlert({
//         type: "Failed",
//         title: "Invalid Barcode for this product",
//         duration: 2500,
//       });
//         return;
//       }

//       // 2️⃣ Out of stock
//       if (batch.quantity <= 0) {
//          showAlert({
//         type: "Failed",
//         title: "Out of Stock",
//         duration: 2500,
//       });
//         return;
//       }

//       // 3️⃣ Quantity validation
//       const currentPkg = packagedQty[selectedProduct.product_id] || 0;
//       const orderedQty = selectedProduct.quantity;

//       if (currentPkg + 1 > orderedQty) {
//          showAlert({
//         type: "Failed",
//         title: "Cannot package more than ordered quantity",
//         duration: 2500,
//       });
//         return;
//       }

//       // 4️⃣ Update packaged quantity UI
//       setPackagedQty((prev) => ({
//         ...prev,
//         [selectedProduct.product_id]: currentPkg + 1,
//       }));

//       // 5️⃣ Deduct stock from batch
//       await axios.post(
//         `http://localhost:5000/api/batch/${batch.batch_id}/deduct`,
//         { quantity: 1 }
//       );

//        showAlert({
//         type: "success",
//         title: "Package Added Successfully(1)",
//         duration: 2500,
//       });

//     } catch (err) {
//       console.error("Barcode check error:", err);
//        showAlert({
//         type: "Failed",
//         title: "Server Error While Checking Barcode",
//         duration: 2500,
//       });
//     }
//   };

//   const handleStatusAction = async (id) => {
//     try {
//       await OrderStatus(id, modalStatus);
//       if (handleRefetch) handleRefetch();
//       closeModal();
//     } catch (err) {
//       console.error("Status update error:", err);
//     }
//   };

//   return (
//     <>
//       {/* ORDER CARD */}
//       <div className="w-full mx-auto bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">

//         {/* HEADER */}
//         <div className="px-6 py-4 bg-gray-50 border-b flex justify-between">
//           <div>
//             <p className="text-xs text-gray-500">Order ID</p>
//             <h3 className="font-bold text-lg">{orderId}</h3>
//           </div>

//           <div className="flex items-center gap-3">
//             <span>{formatDate(orderDetails.created_at)}</span>
//             <span
//               className={`px-3 py-1 rounded-full text-xs font-bold border ${getStatusBadgeClasses(
//                 orderDetails.status
//               )}`}
//             >
//               {orderDetails.status}
//             </span>
//           </div>
//         </div>

//         {/* ITEMS & CUSTOMER */}
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 p-6">

//           {/* ITEMS */}
//           <div className="lg:col-span-2">
//             <h4 className="font-semibold mb-3">Items Ordered</h4>

//             {items.map((item) => (
//               <div
//                 key={item.id}
//                 onClick={() => handleProductClick(item)}
//                 className="flex items-center p-3 border rounded-lg cursor-pointer hover:bg-gray-50"
//               >
//                 <img
//                   src={`${baseURL}/uploads/${item.image_url}`}
//                   className="w-16 h-16 rounded-lg"
//                   alt=""
//                 />

//                 <div className="ml-3 flex-grow">
//                   <p className="font-semibold">{item.combo}</p>
//                   <p className="text-xs text-gray-500">
//                     Product ID: {item.product_id}
//                   </p>
//                   <p className="text-xs text-gray-500">
//                     Qty: {item.quantity}
//                   </p>
//                 </div>

//                 <div className="text-right">
//                   <p className="font-semibold">{formatCurrency(item.amount)}</p>
//                   <p className="text-xs">{formatCurrency(item.amount * item.quantity)}</p>
//                   <p className="text-xs font-bold text-indigo-700">
//                     Packaged: {packagedQty[item.product_id] || 0}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* CUSTOMER */}
//           <div className="lg:col-span-1 bg-gray-50 p-4 rounded-lg">
//             <h4 className="font-semibold mb-3">Customer Details</h4>

//             <p><strong>Name:</strong> {orderDetails.name}</p>
//             <p><strong>Phone:</strong> {orderDetails.phone || orderDetails.mobile}</p>
//             <p><strong>Address:</strong> {orderDetails.address}</p>

//             <div className="mt-4">
//               <p><strong>Payment ID:</strong> {orderDetails.payment_id}</p>
//               <p><strong>Total:</strong> {formatCurrency(calculateTotalAmount())}</p>
//               <p><strong>Paid:</strong> {formatCurrency(orderDetails.payedamount)}</p>
//             </div>
//           </div>
//         </div>

//         {/* FOOTER */}
//         <div className="px-6 py-4 bg-gray-100 border-t flex justify-end">
//           <button
//             onClick={handleRefetch}
//             className="px-4 py-2 rounded"
//           >
//             Refresh
//           </button>
//         </div>
//       </div>

//       {/* PRODUCT MODAL */}
//       {selectedProduct && (
//         <div
//           className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4"
//           onClick={closeModal}
//         >
//           <div
//             className="bg-white rounded-lg w-full max-w-lg shadow-xl"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <img
//               src={`${baseURL}/uploads/${selectedProduct.image_url}`}
//               className="w-full h-64 object-cover rounded-t-lg"
//               alt=""
//             />

//             <div className="p-6">
//               <h2 className="font-bold text-xl">{selectedProduct.combo}</h2>
//               <p className="text-gray-500">Product ID: {selectedProduct.product_id}</p>

//               {/* BARCODE INPUT INSIDE MODAL */}
//               <div className="mt-4">
//                 <label className="text-sm font-semibold">Scan / Enter Barcode</label>
//                 <div className="flex gap-2 mt-1">
//                   <input
//                     type="text"
//                     className="border p-2 rounded w-full"
//                     value={barcodeInput}
//                     onChange={(e) => setBarcodeInput(e.target.value)}
//                     placeholder="Enter barcode..."
//                   />
//                   <button
//                     className="bg-blue-600 text-white px-4 rounded"
//                     onClick={handleBarcodeCheck}
//                   >
//                     Check
//                   </button>
//                 </div>
//               </div>

//               {/* STATUS */}
//               <div className="mt-4 flex items-center justify-between">
//                 <strong>Status:</strong>
//                 <select
//                   value={modalStatus}
//                   onChange={(e) => setModalStatus(e.target.value)}
//                   className="border px-2 py-1 rounded"
//                 >
//                   <option value="Success">Success</option>
//                   <option value="Pending">Pending</option>
//                   <option value="Failed">Failed</option>
//                   <option value="Shipped">Shipped</option>
//                   <option value="Delivered">Delivered</option>
//                   <option value="Cancelled">Cancelled</option>
//                   <option value="Return Initiated">Return Initiated</option>
//                   <option value="Returned">Returned</option>
//                 </select>
//               </div>

              // {/* ACTION BUTTONS */}
              // <div className="mt-6 grid grid-cols-2 gap-3">
              //   <button
              //     onClick={() => handleStatusAction(selectedProduct.id)}
              //     className="bg-indigo-600 text-white py-2 rounded"
              //   >
              //     Update Status
              //   </button>
              //   <button
              //     onClick={closeModal}
              //     className="py-2 rounded"
              //   >
              //     Close
              //   </button>
              // </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default OrderCard;
// OrderCard.jsx (clean, displays packaged qty)
// Place in src/Orders/OrderCard.jsx
import React, { useState } from "react";
import axiosClient from "../global/Globalapi"; // keep if you use for images
import { OrderStatus } from "./OrderFunction";
import { useEffect } from "react";

const OrderCard = ({ orderId, items = [], handleRefetch }) => {
  const baseURL = axiosClient?.defaults?.baseURL || "";
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [modalStatus, setModalStatus] = useState("");
const [localStatusMap, setLocalStatusMap] = useState({});
useEffect(() => {
  if (selectedProduct) {
    setModalStatus(selectedProduct.status || "");
  }
}, [selectedProduct]);
// closes modal safely
const closeModal = () => {
  setSelectedProduct(null);
};

// updates status and then closes modal
// const handleUpdateStatus = async (id, status) => {
//   if (!id || !status) return;

//   try {
//     await OrderStatus(id, status);        // backend call
//     if (handleRefetch) handleRefetch();   // refresh order list
//   } catch (err) {
//     console.error("Status update failed:", err);
//   }
// };

// const handleStatusAction = (id) => {
//   handleUpdateStatus(id, modalStatus); // this already exists in your code
//   closeModal();
// };
const handleUpdateStatus = async (id, status) => {
  if (!id || !status) return;

  try {
    await OrderStatus(id, status);

    setLocalStatusMap((prev) => ({
      ...prev,
      [id]: status,
    }));

    setSelectedProduct((prev) =>
      prev ? { ...prev, status } : prev
    );

    if (handleRefetch) {
      handleRefetch();
    }

    closeModal();
  } catch (err) {
    console.error("Status update failed:", err);
  }
};

const handleStatusAction = async (id) => {
  await handleUpdateStatus(id, modalStatus);
};
  const orderDetails = items[0] || {};

  if (!orderDetails) return null;

  const formatCurrency = (amount) => {
    const num = Number(amount || 0);
    return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 }).format(num);
  };

  const calculateTotalAmount = () => items.reduce((t, it) => t + Number(it.amount || 0) * Number(it.quantity || 1), 0);

  const openProductModal = (it) => setSelectedProduct(it);
  const closeProductModal = () => setSelectedProduct(null);

  return (
    <>
      <div className="w-full mx-auto bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
        <div className="px-6 py-4 bg-gray-50 border-b flex items-center justify-between">
          <div>
            <p className="text-xs font-semibold text-gray-500 uppercase">Order ID</p>
            <h3 className="text-lg font-bold text-gray-900 break-all">{orderId}</h3>
          </div>
          <div className="text-sm text-gray-600">{new Date(orderDetails.created_at || "").toLocaleString()}</div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 px-6 py-5">
          <div className="lg:col-span-2">
            <h4 className="text-base font-semibold text-gray-800 mb-3">Items Ordered</h4>
            <div className="space-y-3">
              {items.map((item) => (
                <div key={item.id} onClick={() => openProductModal(item)} className="flex items-center space-x-4 p-3 border border-gray-100 rounded-lg cursor-pointer hover:bg-gray-50 transition">
                  <img src={`${baseURL}/uploads/${item.image_url}`} alt={item.combo} className="w-16 h-16 rounded-lg object-cover border border-gray-200" />
                  <div className="flex-grow">
                    <p className="font-semibold text-gray-900">{item.combo}</p>
                    <p className="text-xs text-gray-500">Product ID: {item.product_id}</p>
                    <p className="text-xs text-gray-500">Ordered: {item.quantity}</p>
                    {/* <p className="text-xs text-indigo-700 font-semibold">Packaged: {item.pkg_qty || 0} / {item.quantity}</p> */}
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-semibold text-gray-800">{formatCurrency(item.amount)}</p>
                    <p className="text-xs text-gray-600">{formatCurrency(Number(item.amount || 0) * Number(item.quantity || 1))}</p>
                    {/* <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusBadgeClasses(item.status)}`}>{item.status}</span> */}
                  <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusBadgeClasses(localStatusMap[item.id] || item.status)}`}>
  {localStatusMap[item.id] || item.status}
</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-1 bg-gray-50 p-4 rounded-lg border border-gray-100">
            <h4 className="text-base font-semibold text-gray-800 mb-3">Customer Details</h4>
            <div className="text-sm text-gray-700 space-y-2">
              <p><strong>Name:</strong> {orderDetails.name || "-"}</p>
              <p><strong>Phone:</strong> {orderDetails.phone || orderDetails.mobile || "-"}</p>
              <p><strong>Address:</strong> {orderDetails.address || "-"}</p>
            </div>
            <div className="mt-4 text-sm text-gray-700">
              {/* <p><strong>Payment ID:</strong> <span className="font-mono">{orderDetails.payment_id || "-"}</span></p> */}
              <p className="mt-2"><strong>Total:</strong> {formatCurrency(calculateTotalAmount())}</p>
              <p className="mt-1"><strong>Paid:</strong> {formatCurrency(orderDetails.payedamount || 0)}</p>
            </div>
          </div>
        </div>

        <div className="px-6 py-4 bg-white border-t flex justify-end gap-3">
          <button onClick={() => { if (handleRefetch) handleRefetch(); }} className="px-4 py-2 bg-gray-100 border rounded hover:bg-gray-200">Refresh Order</button>
        </div>
      </div>

      {/* product modal */}
      {selectedProduct && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4" onClick={closeProductModal}>
          <div className="bg-white rounded-lg shadow-2xl w-full max-w-lg" onClick={(e) => e.stopPropagation()}>
            <img src={`${baseURL}/uploads/${selectedProduct.image_url}`} alt={selectedProduct.combo} className="w-full h-64 object-cover rounded-t-lg" />
            <div className="p-6">
              <h2 className="text-xl font-bold text-gray-800 mb-1">{selectedProduct.combo}</h2>
              <p className="text-sm text-gray-500 mb-3">Product ID: {selectedProduct.product_id}</p>
              <div className="space-y-2 text-gray-700 text-sm border-t border-b py-3">
                <p className="flex justify-between"><strong>Quantity:</strong> <span>{selectedProduct.quantity}</span></p>
                {/* <p className="flex justify-between"><strong>Packaged:</strong> <span>{selectedProduct.pkg_qty || 0}</span></p> */}
                <p className="flex justify-between"><strong>Amount:</strong> <span>{formatCurrency(selectedProduct.amount || 0)}</span></p>
                {/* STATUS (Editable) */}
<div className="mt-4 flex items-center justify-between">
  <strong>Status:</strong>

  <select
    value={modalStatus}
    onChange={(e) => setModalStatus(e.target.value)}
    className="border px-2 py-1 rounded"
  >
    <option value="Success">Success</option>
    <option value="Pending">Pending</option>
    <option value="Failed">Failed</option>
    <option value="Shipped">Shipped</option>
    <option value="Delivered">Delivered</option>
    <option value="Cancelled">Cancelled</option>
    <option value="Return Initiated">Return Initiated</option>
    <option value="Returned">Returned</option>
  </select>
</div>

              </div>
             <div className="mt-6 grid grid-cols-2 gap-3">
  <button
    onClick={() => handleStatusAction(selectedProduct.id)}
    className="bg-indigo-600 text-white py-2 rounded"
  >
    Update Status
  </button>
  <button
    onClick={closeModal}
    className="py-2 rounded"
  >
    Close
  </button>
</div>

            </div>
          </div>
        </div>
      )}
    </>
  );
};

function getStatusBadgeClasses(status) {
  switch ((status || "").toLowerCase()) {
    case "success": return "bg-green-100 text-green-800 border-green-200";
    case "pending": return "bg-yellow-100 text-yellow-800 border-yellow-200";
    case "failed": return "bg-red-100 text-red-800 border-red-200";
    case "shipped": return "bg-blue-100 text-blue-800 border-blue-200";
    case "intransit": return "bg-orange-100 text-orange-800 border-orange-200";
    case "delivered": return "bg-emerald-100 text-emerald-800 border-emerald-200";
    case "cancelled": return "bg-gray-200 text-gray-800 border-gray-300";
    default: return "bg-gray-100 text-gray-800 border-gray-200";
  }
}

export default OrderCard;
